import { fontSizes, colors } from '../../Components/consts'
import { styled } from '@mui/system'
import { TabPanel } from '../../Components/Tab/TabPanel'
import { Tabs } from '../../Components/LazyComponents'

type AllStarPlayerProps = {
  isSelected?: boolean
}

export const RootCon = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  padding: theme.spacing(4, 0, 8, 0),
  [theme.breakpoints.between('sm', 'md')]: {
    padding: theme.spacing(0, 2, 4, 2),
  },
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(0, 0, 4, 0),
    marginBottom: theme.spacing(2),
  },
}))

export const Background = styled('div')(({ theme }) => ({
  position: 'fixed',
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  zIndex: -1,
  background: colors.gray.gray90,
}))

export const PanelCon = styled(TabPanel)<{ borderRadius?: number; marginTop?: number }>(
  ({ theme, borderRadius, marginTop }) => ({
    width: '100%',
    marginTop: marginTop ? theme.spacing(marginTop) : theme.spacing(0),
    borderRadius: borderRadius
      ? `0 0 ${theme.spacing(borderRadius)} ${theme.spacing(borderRadius)}`
      : `0 0 ${theme.spacing(4)} ${theme.spacing(4)}`,
  })
)

export const ASTabHeader = styled(Tabs)(({ theme }) => ({
  width: '100%',
  background: colors.gray.gray75,
  borderRadius: '8px 8px 0 0',
  '& .MuiTabs-indicator': {
    background: colors.white,
  },
  '& .MuiTab-textColorPrimary.Mui-selected': {
    color: colors.white,
    fontWeight: 'bold',
    [theme.breakpoints.down('sm')]: {
      fontSize: fontSizes.small,
    },
  },
  '&& .MuiTab-textColorPrimary': {
    color: colors.white,
    fontWeight: 700,
    [theme.breakpoints.down('md')]: {
      fontSize: fontSizes.xSmall,
    },
  },
  '& .MuiTab-textColorInherit.Mui-selected': {
    color: colors.white,
    fontWeight: 'bold',
    [theme.breakpoints.down('sm')]: {
      fontSize: fontSizes.small,
    },
  },
  '& .MuiTab-textColorInherit': {
    color: colors.white,
    fontWeight: 500,
    [theme.breakpoints.down('sm')]: {
      fontSize: fontSizes.small,
    },
  },
  '& .MuiTab-root': {
    color: colors.gray.gray40,
    fontWeight: 600,
    [theme.breakpoints.down('sm')]: {
      fontSize: fontSizes.xSmall,
    },
  },
}))

export const HeroCon = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  [theme.breakpoints.down('sm')]: {
    justifyContent: 'space-around',
  },
  '& img': {
    margin: theme.spacing(1),
    borderRadius: 20,
    width: '25%',
    [theme.breakpoints.down('sm')]: {
      width: '49%',
      borderRadius: 8,
      margin: theme.spacing(1, 0.2),
    },
  },
}))

export const ASDesc = styled('div')(({ theme }) => ({
  margin: theme.spacing(0, 3, 5),
  [theme.breakpoints.down('md')]: {
    margin: theme.spacing(3, 12),
  },
  '& p': {
    color: colors.gray.gray40,
    fontWeight: 400,
    fontSize: fontSizes.medium,
    [theme.breakpoints.down('sm')]: {
      fontSize: fontSizes.small,
    },
  },
  '& ul': {
    paddingLeft: 20,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 16,
    },
  },
  '& ul > li': {
    color: colors.gray.gray20,
    fontWeight: 400,
    fontSize: fontSizes.medium,
    listStyleType: 'disc',
    listStylePosition: 'outside',
    [theme.breakpoints.down('md')]: {
      fontSize: fontSizes.xSmall,
      color: colors.gray.gray20,
      listStyleType: 'disc',
      listStylePosition: 'outside',
    },
  },
}))

export const ASGBoxscoreCon = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-around',
  alignItems: 'center',
  margin: theme.spacing(2, 0),
  img: {
    width: '8%',
    margin: theme.spacing(0, 2),
    [theme.breakpoints.down('sm')]: {
      width: 35,
    },
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
}))

export const ASBox = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  margin: theme.spacing(2, 0),
}))

export const ASGTabBackground = styled('div')(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: '50vh',
  background: `
    radial-gradient(circle at 25% 25%, rgba(0, 17, 228, 0.15) 0%, transparent 45%),
    radial-gradient(circle at 75% 75%, rgba(255, 0, 0, 0.15) 0%, transparent 45%),
    radial-gradient(circle at 50% 50%, rgba(255, 255, 255, 0.08) 0%, transparent 70%),
    linear-gradient(135deg, #0f172a 0%, #1e293b 30%, #334155 70%, #0f172a 100%)
  `,
}))

export const ASVoteCon = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  padding: theme.spacing(1, 4, 6, 4),
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1, 2, 6, 2),
  },
  '& img': {
    width: 120,
    borderRadius: 8,
    marginTop: theme.spacing(3),
  },
}))

export const SkillsChallengeCon = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(1, 4, 6, 4),
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1, 2, 6, 2),
  },
  '& .logoCon': {
    display: 'flex',
    justifyContent: 'center',
    margin: theme.spacing(2, 0),
    '& img': {
      width: 120,
    },
  },
  '& .skillsParticipants': {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    margin: theme.spacing(0, 2, 4, 2),
    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(1, 1, 6, 1),
    },
  },
}))

export const SkillsParticipantsCon = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  maxWidth: '95vw',
  '& .skillsParticipantRow': {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    margin: theme.spacing(0, 0, 4, 0),
    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(1, 0, 6, 0),
    },
  },
}))

export const PlayerCol = styled('div')<AllStarPlayerProps>(({ isSelected, theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'flex-start',
  minWidth: 260,
  border: isSelected
    ? `1px solid ${colors.blue}50`
    : `1px solid ${colors.gray.gray20}50`,
  borderRadius: theme.spacing(4),
  margin: theme.spacing(2, 1),
  padding: theme.spacing(3),
  background: isSelected ? `${colors.lightOlive}90` : `${colors.offWhite}70`,
  [theme.breakpoints.down('sm')]: {
    minWidth: '40%',
    padding: theme.spacing(1.5),
    margin: theme.spacing(1),
    border: isSelected
      ? `1px solid ${colors.blue}50`
      : `1px solid ${colors.gray.gray20}`,
  },
  '& .topCon': {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
    '& .profileCon': {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'flex-start',
      maxWidth: 100,
      [theme.breakpoints.down('md')]: {
        maxWidth: 60,
      },
      '& .profile': {
        height: 65,
        objectFit: 'cover',
        borderRadius: '50%',
        [theme.breakpoints.down('md')]: {
          height: 60,
        },
      },
      '& .teamLogo': {
        width: 25,
        objectFit: 'cover',
        zIndex: 3,
        marginLeft: '-12px',
        [theme.breakpoints.down('md')]: {
          width: 15,
          marginLeft: '-10px',
        },
      },
    },

    '& .selectCon': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: '50%',
      background: colors.blue,
      height: 25,
      width: 25,
      cursor: 'pointer',
      [theme.breakpoints.down('sm')]: {
        height: 20,
        width: 20,
      },
    },
  },
  '& .title': {
    fontSize: fontSizes.medium,
    fontWeight: 500,
    [theme.breakpoints.down('sm')]: {
      fontSize: fontSizes.small,
    },
  },
  '& .college': {
    fontSize: '0.9rem',
    fontWeight: 400,
    margin: '2px 0',
    color: colors.text,
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.8rem',
    },
  },
  '& .points': {
    fontSize: '1.1rem',
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.8rem',
    },
  },
  '& a': {
    textDecoration: 'none',
    color: '#242424',
  },
}))
